import * as angular from 'angular';

import { DirectiveDefinition } from './directiveDefinition';
import { IFormatNumberHelper } from '../services';

class WtInputSmartFloatController implements angular.IController {
    static floatRegex = /^\-?\d+((\.|\,)\d+)?([eE][-+]?[0-9]+)?$/;

    hasFocus: boolean;

    readonly decimals: number;
    readonly disableReplace: boolean;
    readonly disableRounding: boolean;
    readonly ngMax: number;
    readonly ngMin: number;

    static $inject = [
        '$element',
        '$timeout',
        'formatNumberHelper'
    ];

    constructor(
        private _$element: angular.IAugmentedJQuery,
        private _$timeout: angular.ITimeoutService,
        private _formatNumberHelper: IFormatNumberHelper
    ) {
    }

    $onInit() {
        const ctrl: angular.INgModelController = this._$element.controller('ngModel');
        if (ctrl) {
            ctrl.$formatters.unshift(modelValue => {
                return this.checkModelValidity(modelValue, ctrl);
            });

            ctrl.$parsers.unshift(viewValue => {
                return this.parseViewValue(viewValue, ctrl);
            });

            ctrl.$validators.min = (modelValue, viewValue) => {
                return this.validateMin(viewValue);
            };

            ctrl.$validators.max = (modelValue, viewValue) => {
                return this.validateMax(viewValue);
            };

            this._$element.on('blur', () => {
                this.hasFocus = false;
                this._$timeout(() => ctrl.$processModelValue());
            });

            this._$element.on('focus', () => {
                this.hasFocus = true;
                ctrl.$setViewValue(ctrl.$modelValue);
                ctrl.$render();
            });
        }
    }

    private validateMax(viewValue: any) {
        const maxValue = this.ngMax;
        let isValid = !viewValue || viewValue === '' || viewValue === '-' || (maxValue == null);
        if (!isValid) {
            const parsed = typeof viewValue === 'number'
                ? viewValue
                : this._formatNumberHelper.parse(viewValue, this.decimals);
            isValid = angular.isNumber(parsed) && (isNaN(parsed) || parsed <= maxValue);
        }
        return isValid;
    }

    private validateMin(viewValue: any) {
        const minValue = this.ngMin;
        let isValid = !viewValue || viewValue === '' || viewValue === '-' || (minValue == null);
        if (!isValid) {
            const parsed = typeof viewValue === 'number'
                ? viewValue
                : this._formatNumberHelper.parse(viewValue, this.decimals);
            isValid = angular.isNumber(parsed) && (isNaN(parsed) || parsed >= minValue);
        }
        return isValid;
    }

    private parseViewValue(viewValue: any, ctrl: angular.INgModelController) {
        // double equal as value can be 0 or '0'
        if (viewValue !== 0 && viewValue !== '0' && (!viewValue || viewValue === '')) {
            ctrl.$setValidity('float', true);
            return null;
        }

        if (WtInputSmartFloatController.floatRegex.test(viewValue)) {
            ctrl.$setValidity('float', true);
            if (typeof viewValue !== 'number') {
                viewValue = parseFloat(viewValue.replace(',', '.'));
            }
            return viewValue;
        } else {
            ctrl.$setValidity('float', false);
            return viewValue;
        }
    }

    private checkModelValidity(modelValue: any, ctrl: angular.INgModelController) {
        const retVal = this._formatNumberHelper.format(modelValue, this.decimals, !this.disableRounding, !this.disableReplace);
        let isValid = true;
        if (modelValue && isValid) {
            isValid = WtInputSmartFloatController.floatRegex.test(modelValue);
        }
        ctrl.$setValidity('float', isValid);
        return isValid ? retVal : modelValue;
    }
}

export const WtInputSmartFloatDirective: DirectiveDefinition = {
    directiveId: 'wtInputSmartFloat',
    restrict: 'A',
    controller: WtInputSmartFloatController,
    controllerAs: 'vm',
    bindToController: true,
    require: ['ngModel'],
    scope: {
        decimals: '<?',
        disableReplace: '<?',
        disableRounding: '<?',
        hasFocus: '=?',
        ngMax: '<?',
        ngMin: '<?',
    }
};